import { AskForOpportunitiesFormData, AskForOpportunitiesFormErrors } from '../types';

export default function formValidate(formData: AskForOpportunitiesFormData) {
    const errors: AskForOpportunitiesFormErrors = {};

    if (!formData.text) {
        errors.text = 'Required';
    }

    return errors.text ? errors : null;
}
